import Logo from "../../assets/Logo.png";
import whatsappImg from "../../assets/whatsapp.png";

// ======================================================
// أيقونة ترس + ساعة SVG — نفس تصميم الصورة
// ======================================================
const MaintenanceIcon = () => (
    <svg
        viewBox="0 0 120 110"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: 130, height: 120 }}
    >
        {/* Gear */}
        <g transform="translate(10,5)">
            <path
                d="M45 0 L51 0 L53 10 Q58 12 62 15 L72 11 L78 17 L74 27 Q77 31 79 36 L89 38 L89 44 L79 46 Q77 51 74 55 L78 65 L72 71 L62 67 Q58 70 53 72 L51 82 L45 82 L43 72 Q38 70 34 67 L24 71 L18 65 L22 55 Q19 51 17 46 L7 44 L7 38 L17 36 Q19 31 22 27 L18 17 L24 11 L34 15 Q38 12 43 10 Z"
                fill="#c8c8c8"
                stroke="#aaa"
                strokeWidth="1"
            />
            {/* Inner circle of gear */}
            <circle cx="48" cy="41" r="16" fill="white" stroke="#bbb" strokeWidth="1.5" />
            {/* Clock face inside gear */}
            <circle cx="48" cy="41" r="13" fill="white" stroke="#bbb" strokeWidth="1" />
            {/* Clock hands */}
            <line x1="48" y1="41" x2="48" y2="32" stroke="#c0392b" strokeWidth="2" strokeLinecap="round" />
            <line x1="48" y1="41" x2="55" y2="41" stroke="#c0392b" strokeWidth="2" strokeLinecap="round" />
            {/* Center dot */}
            <circle cx="48" cy="41" r="2" fill="#c0392b" />
        </g>
        {/* Wrench */}
        <g transform="translate(58, 58) rotate(-40)">
            <rect x="-5" y="-28" width="10" height="45" rx="5" fill="#c0392b" />
            <ellipse cx="0" cy="-28" rx="10" ry="7" fill="#c0392b" />
            <rect x="-3" y="-32" width="6" height="10" rx="1" fill="#a93226" />
        </g>
    </svg>
);

// ======================================================
// صفحة الإغلاق الرئيسية
// ======================================================
const SiteClosedPage = ({ vacationInfo }) => {
    const { type, reason, dateFrom, dateTo, dayName } = vacationInfo || {};

    // بناء نص التفاصيل حسب نوع الإغلاق
    let detailText = "";
    if (type === "interval" && reason) {
        detailText = reason;
        if (dateFrom && dateTo) {
            detailText += `\nمن ${dateFrom} إلى ${dateTo}`;
        }
    } else if (type === "weekend" && dayName) {
        detailText = `عطلة أسبوعية — ${dayName}`;
    } else {
        detailText = "الموقع مغلق مؤقتاً.";
    }

    return (
        <div
            dir="rtl"
            style={{
                minHeight: "100vh",
                background: "linear-gradient(160deg, #fdf8f4 0%, #f5ede6 100%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px 80px",
                fontFamily: "Cairo, sans-serif",
                position: "relative",
            }}
        >
            {/* Logo */}
            <img
                src={Logo}
                alt="Meat House Al Fardous"
                style={{
                    width: 180,
                    height: "auto",
                    marginBottom: 32,
                    filter: "drop-shadow(0 4px 16px rgba(0,0,0,0.13))",
                }}
            />

            {/* Maintenance Icon */}
            <div style={{ marginBottom: 28 }}>
                <MaintenanceIcon />
            </div>

            {/* Main title */}
            <h1
                style={{
                    fontSize: 26,
                    fontWeight: "bold",
                    color: "#1a1a1a",
                    textAlign: "center",
                    marginBottom: 30,
                    lineHeight: 1.5,
                }}
            >
                نأسف لعدم توفر الخدمة حالياً
            </h1>

            {/* Details card */}
            <div
                style={{
                    width: "100%",
                    maxWidth: 420,
                    background: "#ffffff",
                    border: "2px solid #c0392b55",
                    borderRadius: 16,
                    padding: "22px 28px",
                    textAlign: "center",
                    marginBottom: 28,
                    boxShadow: "0 2px 16px rgba(192,57,43,0.08)",
                    whiteSpace: "pre-line",
                }}
            >
                {detailText ? (
                    <p
                        style={{
                            color: "#555",
                            fontSize: 18,
                            margin: 0,
                            lineHeight: 1.8,
                        }}
                    >
                        {detailText}
                    </p>
                ) : (
                    <p
                        style={{
                            color: "#aaa",
                            fontSize: 17,
                            margin: 0,
                        }}
                    >
                        تفاصيل العطلة او الصيانة
                    </p>
                )}
            </div>

            {/* Footer message */}
            <p
                style={{
                    color: "#555",
                    fontSize: 17,
                    textAlign: "center",
                    margin: 0,
                }}
            >
                نقدر تفهمكم، ونسعد بخدمتكم قريباً.
            </p>

            {/* WhatsApp floating button */}
            <a
                href="https://api.whatsapp.com/send?phone=201143837483"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    bottom: 30,
                    left: 24,
                    zIndex: 999,
                    display: "block",
                    animation: "waPulse 2s infinite",
                }}
            >
                <img
                    src={whatsappImg}
                    alt="WhatsApp"
                    style={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        boxShadow: "0 4px 20px rgba(37,211,102,0.45)",
                        objectFit: "contain",
                    }}
                />
            </a>

            {/* Pulse animation */}
            <style>{`
                @keyframes waPulse {
                    0%, 100% { transform: scale(1); box-shadow: 0 4px 20px rgba(37,211,102,0.45); }
                    50% { transform: scale(1.08); box-shadow: 0 6px 28px rgba(37,211,102,0.6); }
                }
            `}</style>
        </div>
    );
};

export default SiteClosedPage;
